import React, { useState } from 'react';
import { Popper, ClickAwayListener } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Calendar from '@rcg/ui-react/lib/assets/svg/calendar';
import VerticalDivider from '@rcg/ui-react/lib/components/Icons/VerticalDivider';
import Theme from '@rcg/ui-react/lib/theme';
import { buildCalendarStateObject } from '@rcg/ui-react/lib/utils/dates';
import Picker from './Picker';
import InputRange from './InputRange';
import InputsDate from './InputsDate';
import useStyles from './index.style';

const Datepicker = (props) => {
  const isDesktop = useMediaQuery(Theme.breakpoints.up('md'));
  const classes = useStyles();

  const {
    datepickerIcon = <Calendar />,
    datepickerEndIcon = <Calendar />,
    dividerInputIcon = <VerticalDivider />,
    labelDatepicker = 'Dates',
    backOptionLabel,
    labelStartDate = 'Departure date',
    labelEndDate = 'Return date',
    placeholderStartDate = 'Start date',
    placeholderEndDate = 'End date',
    yourDatesLabel,
    incomingStartDate = '2021/03/01',
    incomingEndDate = '2021/03/25',
    incomingStartDefaultDate = '2021/03/01',
    incomingEndDefaultDate = '2021/03/25',
    minAvailableDate = '2021/01/29',
    maxAvailableDate = '2021/04/25',
    resetDatesButtonLabel,
    submitDatesButtonLabel,
    cancelButtonLabel = 'Cancel',
    forceSplitInputs = false,
    forceRangeInputs = false,
    onSelectedDates = () => {},
    oneWay = false,
  } = props;

  const [state, setState] = useState(
    buildCalendarStateObject(incomingStartDefaultDate, incomingEndDefaultDate),
  );
  const [anchorEl, setAnchorEl] = useState(null);

  const [open, setOpen] = useState(false);
  const id = open ? 'simple-popover' : undefined;

  const resetCalendar = () => {
    setState(buildCalendarStateObject(incomingStartDate, incomingEndDate));
  };

  const handleDoneClick = (dates) => {
    if (state.startDate === null || state.endDate === null) {
      resetCalendar();
    }
    setState(dates);
    onSelectedDates(dates);
    setOpen(false);
    setAnchorEl(null);
  };

  const handleDatepicker = (dates) => {
    if (state.startDate === null || state.endDate === null) {
      resetCalendar();
    }
    setState(dates);
    onSelectedDates(dates);
  };

  const handleClick = (event) => {
    setOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const dateInput =
    (!isDesktop && !forceRangeInputs) || forceSplitInputs ? (
      <InputsDate
        dividerInputIcon={dividerInputIcon}
        datepickerIcon={datepickerIcon}
        yourDatesLabel={yourDatesLabel}
        datepickerEndIcon={datepickerEndIcon}
        placeholderStartDate={placeholderStartDate}
        placeholderEndDate={placeholderEndDate}
        labelStartDate={labelStartDate}
        labelEndDate={labelEndDate}
        incomingStartDate={incomingStartDate}
        incomingEndDate={incomingEndDate}
        maxAvailableDate={maxAvailableDate}
        minAvailableDate={minAvailableDate}
        backOptionLabel={backOptionLabel}
        startDate={state.startDate}
        endDate={state.endDate}
        resetDatesButtonLabel={resetDatesButtonLabel}
        cancelButtonLabel={cancelButtonLabel}
        submitDatesButtonLabel={submitDatesButtonLabel}
        onDateChange={handleDoneClick}
        handleClose={handleClose}
        resetCalendar={resetCalendar}
        oneWay={oneWay}
      />
    ) : (
      <InputRange
        datepickerIcon={datepickerIcon}
        dividerInputIcon={dividerInputIcon}
        placeholderStartDate={placeholderStartDate}
        placeholderEndDate={placeholderEndDate}
        incomingStartDate={incomingStartDate}
        incomingEndDate={incomingEndDate}
        maxAvailableDate={maxAvailableDate}
        minAvailableDate={minAvailableDate}
        handleDatepicker={handleClick}
        yourDatesLabel={yourDatesLabel}
        backOptionLabel={backOptionLabel}
        labelDatepicker={`${labelDatepicker}`}
        startDate={state.startDate}
        endDate={state.endDate}
        cancelButtonLabel={cancelButtonLabel}
        onDateChange={handleDoneClick}
        resetCalendar={resetCalendar}
        resetDatesButtonLabel={resetDatesButtonLabel}
        submitDatesButtonLabel={submitDatesButtonLabel}
        oneWay={oneWay}
      />
    );

  return (
    <div>
      {dateInput}
      <Popper
        className={classes.popup}
        id={id}
        open={open}
        anchorEl={anchorEl}
        placement="top-end"
        disablePortal={false}
        modifiers={{
          offset: {
            offset: '40, 0',
          },
        }}>
        <ClickAwayListener onClickAway={handleClose}>
          <Picker
            maxAvailableDate={maxAvailableDate}
            minAvailableDate={minAvailableDate}
            startDate={state.startDate}
            endDate={state.endDate}
            yourDatesLabel={yourDatesLabel}
            incomingStartDate={incomingStartDate}
            incomingEndDate={incomingEndDate}
            submitDatesButtonLabel={submitDatesButtonLabel}
            resetDatesButtonLabel={resetDatesButtonLabel}
            onDateChange={handleDoneClick}
            resetCalendar={resetCalendar}
            oneWay={oneWay}
            handleDatepicker={handleDatepicker}
          />
        </ClickAwayListener>
      </Popper>
    </div>
  );
};

export default Datepicker;
